/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Contents_TermInputs */

const en_marketing_faq_contents_term = /** @type {(inputs: Marketing_Faq_Contents_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What exactly do I get?`)
};

const es_marketing_faq_contents_term = /** @type {(inputs: Marketing_Faq_Contents_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué incluye exactamente?`)
};

const fr_marketing_faq_contents_term = /** @type {(inputs: Marketing_Faq_Contents_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que j'obtiens exactement ?`)
};

/**
* | output |
* | --- |
* | "What exactly do I get?" |
*
* @param {Marketing_Faq_Contents_TermInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_contents_term = /** @type {((inputs?: Marketing_Faq_Contents_TermInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Contents_TermInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_contents_term(inputs)
	if (locale === "es") return es_marketing_faq_contents_term(inputs)
	return fr_marketing_faq_contents_term(inputs)
});